<template>
  <div>
    <div class="overlay"></div>
    <div class="container">
      <div class="row">
        <nav class="navbar navbar-expand-lg mh-nav nav-btn">
          <a class="navbar-brand pt-2 logo" href="/">
            <logo></logo>
          </a>
          <button @click="clickMobileMenu()" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-0 ml-auto">
              <li class="nav-item pc-display-none mb-5">
                <a class="nav-link" href="/#mh-home" @click="clickMobileMenu()">
                  <logo></logo>
                </a>
              </li>
              <v-spacer></v-spacer>
              <li class="nav-item">
                <a class="nav-link" href="/#mh-home" @click="clickMobileMenu()">
                    <i class="fa-solid fa-house pc-display-none mr-5"></i>
                    <span>{{ $t('navigation.home') }}</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/#mh-about" @click="clickMobileMenu()">
                    <i class="fa-solid fa-address-card pc-display-none mr-5"></i>
                    <span>{{ $t('navigation.about') }}</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/#mh-skills" @click="clickMobileMenu()">
                    <i class="fa-solid fa-kitchen-set pc-display-none mr-5"></i>
                    <span>{{ $t('navigation.skills') }}</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/#mh-experience" @click="clickMobileMenu()">
                    <i class="fa-solid fa-book-open-reader pc-display-none mr-5"></i>
                    <span>{{ $t('navigation.experiences') }}</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/#mh-project" @click="clickMobileMenu()">
                    <i class="fa-solid fa-bars-progress pc-display-none mr-5"></i>
                    <span>{{ $t('navigation.projects') }}</span>
                </a>
              </li>
              <!-- <li class="nav-item">
                <a class="nav-link" href="#mh-portfolio" @click="clickMobileMenu()">
                    <i class="fa-solid fa-rectangle-list pc-display-none mr-5"></i>
                    <span>作品</span>
                </a>
              </li> -->
              <li class="nav-item">
                <a class="nav-link" href="/#mh-blog" @click="clickMobileMenu()">
                    <i class="fa-solid fa-blog pc-display-none mr-5"></i>
                    <span>{{ $t('navigation.blog') }}</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/#mh-contact" @click="clickMobileMenu()">
                    <i class="fa-solid fa-phone pc-display-none mr-5"></i>
                    <span>{{ $t('navigation.contact') }}</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from '@/components/Logo.vue'
export default {
  data() {
    return {
      // 手机菜单
      mobileMenuOpen: false,
    };
  },
  components: { Logo },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
      test(){
          alert(1)
      },
    clickMobileMenu() {
      if (this.mobileMenuOpen) {
        $(".overlay.active").attr("class", "overlay");
        $(".navbar-collapse.active").attr("class", "navbar-collapse");
      } else {
        $(".overlay").attr("class", "overlay active");
        $(".navbar-collapse").attr("class", "navbar-collapse active");
      }
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue